// Governance-drawer-local constants. Keep magic strings/objects here so
// the drawer body stays declarative.

/* Drawer sheet dimensions (mirrors Concept drawer for visual parity). */
export const GOVERNANCE_DRAWER_SHEET_CLS =
  "z-[80] flex h-full w-[1400px] max-w-[95vw] flex-col gap-0 border-l border-border bg-background p-0 sm:max-w-[95vw]";
export const GOVERNANCE_DRAWER_OVERLAY_CLS = "z-[80]";

/* Copy strings surfaced by the drawer shell. */
export const GOVERNANCE_DRAWER_COPY = {
  title: "Governance",
  description:
    "Ownership, approval, review cycles and monitoring controls declared by this document.",
  loading: "Loading governance...",
  headerBlurb:
    "Ownership, approval, review cadence and monitoring controls declared by this document.",
  validatedLabel: "Validated",
  footerLabel: "Governance · Certified",
  viewEvidence: "View source evidence",
  overallLabel: "Overall governance",
  postureLabel: "POSTURE",
  aiLabel: "AI",
  assessmentLabel: "Governance assessment",
  governanceIndexLabel: "Governance index",
  postureCaption: "Posture",
} as const;

/* Section header + right-label copy. */
export const GOVERNANCE_SECTION_COPY = {
  summary: {
    header: "Governance summary",
    right: "Ownership · approval · review · monitoring",
  },
  highlight: {
    header: "Governance highlight",
    right: "Posture summary",
  },
  ownership: { header: "Ownership & accountability" },
  approvals: { header: "Approval authority" },
  reviewCycles: { header: "Review cycles" },
  controls: { header: "Governance controls" },
  findings: { header: "Governance findings" },
} as const;

/* Missing-controls banner. */
export const GOVERNANCE_MISSING_BANNER = {
  guidance:
    "Add the missing effective date and formal policy review cadence to strengthen the governance posture of this document.",
  wrapCls:
    "flex items-start gap-2 rounded-lg border border-amber-500/30 bg-amber-500/10 p-3 text-[12px] text-amber-300",
  titleCls: "font-semibold text-amber-200",
} as const;

/* Table paging + heights. */
export const GOVERNANCE_CONTROLS_PAGE_SIZE = 6;
export const GOVERNANCE_FINDINGS_PAGE_SIZE = 5;
export const GOVERNANCE_CONTROLS_MAX_HEIGHT = "380px";
export const GOVERNANCE_FINDINGS_MAX_HEIGHT = "360px";

/* Reused pill/box class strings. */
export const SEVERITY_PILL_BASE_CLS =
  "inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold";
export const VALIDATED_PILL_CLS =
  "inline-flex items-center gap-1 rounded-full bg-emerald-500/15 px-2 py-0.5 text-[11px] font-semibold text-emerald-400";
export const VALIDATED_DOT_CLS = "size-1.5 rounded-full bg-emerald-400";
export const OVERALL_SCORE_TEXT_CLS = "text-3xl font-bold text-emerald-400 tabular-nums";
export const APPROVAL_ICON_BOX_CLS =
  "flex size-8 flex-none items-center justify-center rounded-md bg-indigo-500/15 border border-indigo-500/25";
export const APPROVAL_ICON_CLS = "size-4 text-indigo-400";
export const REVIEW_ICON_BOX_CLS =
  "flex size-8 flex-none items-center justify-center rounded-md bg-cyan-500/15 border border-cyan-500/25";
export const REVIEW_ICON_CLS = "size-4 text-cyan-400";
export const POSTURE_PILL_CLS =
  "inline-flex items-center rounded-md bg-teal-500/15 px-2 py-0.5 text-[11px] font-bold tracking-wide text-teal-300 border border-teal-500/25";
export const AI_BADGE_CLS =
  "inline-flex items-center gap-1 rounded-md bg-gradient-to-r from-teal-500 to-emerald-500 px-1.5 py-0.5 text-[10px] font-bold text-white";
export const AI_LABEL_CLS = "text-[11px] tracking-wide text-teal-300 font-semibold";
export const AI_WRAP_CLS = "rounded-lg border border-teal-500/30 bg-teal-500/10 p-3";
export const DOCUMENTED_PILL_CLS =
  "inline-flex items-center gap-1 rounded-full bg-emerald-500/15 px-1.5 py-0.5 text-[10px] font-semibold text-emerald-400";
